var monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
var accessLevels = [
    "1 - Own Production",
    "2 - Sub-Branch",
    "3 - Master Branch",
    "4 - Region",
    "5 - Executive",
];
var employeeIdentifiers = [
    "0 - Last Name, First Name - 'Originator, Olive'",
    "1 - Last Name, First Name Primary Employee Number - 'Originator, Olive 1234'",
    "2 - Last Name, First Name (Branch) - 'Originator, Olive (100)'",
    "3 - Last Name, First Name Primary Employee Number (Branch) - 'Originator, Olive 1234 (100)'",
    "4 - Primary Employee Number Last Name, First Name - '1234 Originator, Olive'",
    "5 - Primary Employee Number Last Name, First Name (Branch) - '1234 Originator, Olive (100)'",
    "6 - First Name Last Name - 'Olive Originator'",
    "7 - Primary Employee Number First Name Last Name - '1234 Olive Originator'",
    "8 - First Name Last Name Primary Employee Number - 'Olive Orignator 1234'"
];
function formatDateMMYYYY(data, type, full) {
    return formatDateMMYYYYRaw(data);
}
function formatDateMMDDYYYY(data, type, full) {
    if (type == 'display') {
        return formatDateMMDDYYYYRaw(data);
    }
    return data;
}
function formatDateMMDDYYYYHHMMD(data, type, full) {
    if (type == 'display') {
        var m = moment(data);
        var roundUp = m.minute() || m.second() || m.millisecond() ? m.add(1, 'hour').startOf('hour') : m.startOf('hour');
        return roundUp.format("MM/DD/YYYY h:mmA ddd");
    }
    return data;
}
function formatDateMMDDYYYYD(data, type, full) {
    if (type == 'display') {
        return moment(data).format("MM/DD/YYYY ddd");
    }
    return data;
}
function formatDateMMDDYYYYHHMM(data, type, full) {
    if (type == 'display') {
        return formatDateMMDDYYYYHHMMRaw(data);
    }
    return data;
}
function formatDateMMDDYYYYHHMM2digitHour(data, type, full) {
    return formatDateMMDDYYYYHHMM2digitHourRaw(data);
}
function formatDateMMDDYY(data, type, full) {
    if (type === "display") {
        return formatDateMMDDYYRaw(data);
    }
    return formatDateYYYYMMDDRaw_NoSeparator(data);
}
function formatDatePeriodStartStop(data, type, full) {
    var startDt;
    var stopDt;
    var separator;
    if (data && data != null) {
        startDt = formatDateMMDDYYYYRaw(data);
        if (full.StopDt && full.StopDt != null) {
            separator = " - ";
            stopDt = formatDateMMDDYYYYRaw(full.StopDt);
        }
        else {
            stopDt = "";
            separator = "";
        }
    }
    else {
        startDt = "N/A";
        stopDt = "";
        separator = "";
    }
    return startDt + separator + stopDt;
}
function formatDatePeriodActiveInactive(data, type, full) {
    var startDt;
    var stopDt;
    var separator;
    if (data && data != null) {
        startDt = formatDateMMDDYYYYRaw(data);
        if (full.InactiveDt && full.InactiveDt != null) {
            separator = " - ";
            stopDt = formatDateMMDDYYYYRaw(full.InactiveDt);
        }
        else {
            stopDt = "";
            separator = "";
        }
    }
    else {
        startDt = "N/A";
        stopDt = "";
        separator = "";
    }
    return startDt + separator + stopDt;
}
function formatAddressBrFull(data, type, full) {
    var address1;
    var address2;
    var separator = "";
    if (data && data != null) {
        address1 = data;
        if (full.AddressBr2 && full.AddressBr2 != null) {
            address2 = full.AddressBr2;
            separator = ", ";
        }
        else {
            address2 = "";
        }
    }
    else {
        address1 = "";
        address2 = "";
    }
    return address1 + separator + address2;
}
function pad(num, size) {
    var s = num + "";
    while (s.length < size) {
        s = "0" + s;
    }
    return s;
}
function formatMonthYear(data, type, full) {
    if (type === "display") {
        return data;
    }
    var rc = "";
    if (null != data) {
        var arrMonthYear = data.split("-");
        if (arrMonthYear.length === 2) {
            var monthNum = monthsShort.indexOf(arrMonthYear[0]) + 1;
            rc = arrMonthYear[1] + pad(monthNum.toString(), 2);
        }
    }
    return rc;
}
function formatMonth(data, type, full) {
    var rc = "";
    if (null != data && data <= 12) {
        rc = months[data - 1];
    }
    return rc;
}
function formatYesNo(data, type, full) {
    return formatYesNoRaw(data);
}
function formatNullToNA(data, type, full) {
    if (data == null) {
        return "N/A";
    }
    else {
        return data;
    }
}
function formatDateMMYYYYRaw(o) {
    var rc = null;
    var temp = o;
    if ((null != o) && (o instanceof Date === false)) {
        temp = moment(o).toDate();
    }
    if (temp != null) {
        rc = "" + (temp.getMonth() + 1) + "/" + temp.getFullYear();
    }
    return rc;
}
function formatDateMMMYYYYRaw(o) {
    var rc = null;
    var temp = o;
    if ((null != o) && (o instanceof Date === false)) {
        temp = moment(o).toDate();
    }
    if (temp != null) {
        rc = "" + monthsShort[temp.getMonth()] + "-" + temp.getFullYear();
    }
    return rc;
}
function formatDateMMDDYYYYRaw(o) {
    var rc = null;
    var temp = o;
    if ((null != o) && (o instanceof Date === false)) {
        temp = moment(o).toDate();
    }
    if (temp != null) {
        rc = "" + pad((temp.getMonth() + 1), 2) + "/" + pad(temp.getDate(), 2) + "/" + temp.getFullYear();
    }
    return rc;
}
function formatDateMMDDYYYYHHMMRaw(o) {
    var rc = null;
    if (null != o && moment(o).isValid()) {
        rc = moment(o).format("MM/DD/YYYY h:mm A");
    }
    return rc;
}
function formatDateMMDDYYYYHHMM2digitHourRaw(o) {
    var rc = null;
    if (null != o && moment(o).isValid()) {
        rc = moment(o).format("MM/DD/YYYY hh:mm A");
    }
    return rc;
}
function formatDateMMDDYYRaw(o) {
    var rc = null;
    var temp = o;
    if ((null != o) && (o instanceof Date === false)) {
        temp = moment(o).toDate();
    }
    if (temp != null) {
        rc = "" + pad((temp.getMonth() + 1), 2) + "/" + pad(temp.getDate(), 2) + "/" + temp.getFullYear().toString().substr(-2);
    }
    return rc;
}
function formatDateYYYYMMDDRaw_NoSeparator(o) {
    var rc = null;
    var temp = o;
    if ((null != o) && (o instanceof Date === false)) {
        temp = moment(o).toDate();
    }
    if (temp != null) {
        rc = "" + temp.getFullYear().toString() + pad((temp.getMonth() + 1), 2) + pad(temp.getDate(), 2);
    }
    return rc;
}
function lastDayOfMonth(monthYear) {
    return (new Date(monthYear.getFullYear(), monthYear.getMonth() + 1, 0, 0, 0, 0, 0));
}
function formatIfDate(data, type, full) {
    if (type === "display") {
        return formatIfDateRaw(data);
    }
    return data;
}
function formatIfDateRaw(o) {
    var rc = o;
    if ((null != o) && (moment(o).isValid())) {
        rc = moment(o).format("MM/DD/YYYY");
        return rc;
    }
    return rc;
}
function formatYesNoRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o === false) {
            rc = "No";
        }
        else if (o === true) {
            rc = "Yes";
        }
        else {
            rc = "";
        }
    }
    return rc;
}
function formatTrueFalseRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o === 0 || o === "0") {
            rc = "False";
        }
        else if (o === 1 || o === "1") {
            rc = "True";
        }
        else {
            rc = "";
        }
    }
    return rc;
}
function formatEmployeeIdentifierRaw(o) {
    var rc;
    rc = employeeIdentifiers[o];
    return rc;
}
function formatAccessLevelRaw(o) {
    var rc;
    rc = accessLevels[o - 1];
    return rc;
}
function formatChangeType(o) {
    var rc = null;
    if (o === "D") {
        rc = "Deleted";
    }
    if (o === "I") {
        rc = "Inserted";
    }
    if (o === "U") {
        rc = "Updated";
    }
    return rc;
}
function showNull(o) {
    var rc = o;
    if (o == null) {
        rc = "NULL";
    }
    return rc;
}
function returnAsIntegration(o) {
    var rc = o;
    if (o === "Integration, Admin") {
        rc = "Integration";
    }
    else if (o === "Application, Admin") {
        rc = "Application";
    }
    return rc;
}
function formatCSZRaw(city, st, zip) {
    var rc = "";
    if (city) {
        rc = city;
    }
    if (st) {
        if (rc.length > 0) {
            rc += ", ";
        }
        rc += st;
    }
    if (zip) {
        if (rc.length > 0) {
            rc += " ";
        }
        rc += zip;
    }
    return rc;
}
function formatBoolCheckbox(data, type, full) {
    var tmpData = (data + "").toLowerCase() === "true" || ((data + "").toLowerCase() === "false" ? false : data);
    if (type === "display") {
        var result = "";
        if (true === tmpData) {
            result = "<div><input type='checkbox' class='checkbox-center' disabled checked /></div>";
        }
        else {
            result = "<div><input type='checkbox' class='checkbox-center' disabled /></div>";
        }
        return result;
    }
    if (true === tmpData) {
        return 0;
    }
    else {
        return 1;
    }
}
function formatPayrollTransactionDetailLoanNo(data, type, full) {
    var loanLinkFormat = "<a href='" + ResolveUrl("~/ng/loan-details/") + "${LoanNo}' >${LoanNo}</a>";
    var loanNo = $.trim(data);
    var result = loanLinkFormat.replace(/\$\{LoanNo\}/g, loanNo);
    return result;
}
function formatPayrollTransactionDetailAdjType(data, type, full) {
    var result = data;
    if (full["ManualDraw"]) {
        result = "<a href='" + ResolveUrl("~/ng/draw-recapture") + "/" + full["DrwID"] + "/" + full["TranID"] + "/view" + "' >" + data + "</a>";
    }
    else if (full["ManualAdj"] && full["TranID"] > 0) {
        result = "<a href='" + ResolveUrl("~/ng/manual-adjustment/view/") + full["TranID"] + "' >" + data + "</a>";
    }
    return result;
}
function formatPayrollTransactionDetailAdjTypeNew(data, type, full) {
    var result = data;
    if (full["ManualDraw"]) {
        result = "<a href='" + ResolveUrl("~/ng/draw-recapture") + "/" + full["DrwID"] + "/" + full["TranID"] + "/view" + "' >" + data + "</a>";
    }
    else if (full["ManualAdj"] && full["Id"] > 0) {
        result = "<a href='" + ResolveUrl("~/ng/manual-adjustment/view/") + full["Id"] + "' >" + data + "</a>";
    }
    return result;
}
function formatMailTo(data, type, full) {
    var result = $.trim(data);
    result = "<a href='mailto:" + result + "'>" + result + "</a>";
    return result;
}
function formatPhone(data, type, full) {
    var result = $.trim(data);
    if (result !== null && result !== "") {
        result = result.substr(0, 3) + "-" + result.substr(3, 3) + "-" + result.substr(6, 4);
    }
    return result;
}
function formatEmail(data, type, full) {
    var result = $.trim(data);
    if (result !== null && result !== "" && !isNaN(parseInt(result.substr(result.length - 6)))) {
        result = result.substr(0, result.length - 6);
    }
    return result;
}
function formatTier1Description(data, type, full) {
    if (type === "display") {
        return formatTierDescriptionRaw(full["TierGoalUnits1"], full["TierGoalVol1"], full["TierTypeAndOr"], full["TierPayAmt1"], full["PayoutType"]);
    }
    else {
        return data;
    }
}
function formatTier2Description(data, type, full) {
    if (type === "display") {
        return formatTierDescriptionRaw(full["TierGoalUnits2"], full["TierGoalVol2"], full["TierTypeAndOr"], full["TierPayAmt2"], full["PayoutType"]);
    }
    else {
        return data;
    }
}
function formatTier3Description(data, type, full) {
    if (type === "display") {
        return formatTierDescriptionRaw(full["TierGoalUnits3"], full["TierGoalVol3"], full["TierTypeAndOr"], full["TierPayAmt3"], full["PayoutType"]);
    }
    else {
        return data;
    }
}
function formatTierLastDescription(data, type, full) {
    if (type === "display") {
        return formatTierDescriptionRaw(full["TierGoalUnitsLast"], full["TierGoalVolLast"], full["TierTypeAndOr"], full["TierPayAmtLast"], full["PayoutType"]);
    }
    else {
        return data;
    }
}
function formatTierDescriptionRaw(units, volume, andor, payamt, payouttype) {
    var rc = "";
    var payouttypedisplay = null;
    if (payouttype != null) {
        payouttypedisplay = (payouttype.toLowerCase() === "flatflat") ? "Flat $ Amount" : payouttype;
    }
    switch (andor) {
        case "AND":
            if ((null != units) && (null != volume) && (null != payamt) && (null != payouttypedisplay)) {
                rc = ">=" + units + " AND >=" + volume + ": " + payamt + " " + payouttypedisplay;
            }
            break;
        case "OR":
            if ((null != units) && (null != volume) && (null != payamt) && (null != payouttypedisplay)) {
                rc = ">=" + units + " OR >=" + volume + ": " + payamt + " " + payouttypedisplay;
            }
            break;
        default:
            if ((null != units) && (null != payamt) && (null != payouttypedisplay)) {
                rc = ">=" + units + ": " + payamt + " " + payouttypedisplay;
            }
            else if ((null != volume) && (null != payamt) && (null != payouttypedisplay)) {
                rc = ">=" + volume + ": " + payamt + " " + payouttypedisplay;
            }
            else if ((null != payamt) && (null != payouttypedisplay)) {
                rc = ">=0: " + payamt + " " + payouttypedisplay;
            }
            break;
    }
    return rc;
}
function formatPayoutType(data, type, full) {
    var result = data;
    switch (data) {
        case "Flat":
            result = "Flat";
            break;
        case "BPS":
            result = "BPS";
            break;
        case "FlatFlat":
            result = "Flat $ Amount";
            break;
        case "Revenue %":
            result = "% of Revenue";
            break;
    }
    return result;
}
function formatTierPayAmount(data, type, full) {
    if (full.PayoutType === "BPS") {
        return data.toFixed(3);
    }
    else if (full.PayoutType === "Revenue %") {
        return (data / 100).toLocaleString('en-US', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    else {
        return data.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
}
function formatCommScheduleLink(data, type, full) {
    var result = data;
    if (typeof result == "string") {
        result = replaceSpecialChars(result);
    }
    if ("NONE" !== data) {
        var commID = full["CommID"];
        result = "<a href='" + ResolveUrl("~/ng/schedules/") + commID + "' >" + result + "</a>";
    }
    return result;
}
function formatEmpCommScheduleLink(data, type, full) {
    var result = data;
    if (typeof result == "string") {
        result = replaceSpecialChars(result);
    }
    if ("NONE" !== data) {
        var empCommID = full["EmpCommID"];
        result = "<a href='" + ResolveUrl("~/ng/employee-schedules/") + empCommID + "' >" + result + "</a>";
    }
    return result;
}
function formatCommAllocLink(data, type, full) {
    var result = data;
    if (typeof result == "string") {
        result = replaceSpecialChars(result);
    }
    if ("NONE" !== data) {
        var allocID = full["AllocID"];
        result = "<a href='" + ResolveUrl("~/ng/commission-allocations/") + allocID + "' >" + result + "</a>";
    }
    return result;
}
function formatEmpCommAllocLink(data, type, full) {
    var result = data;
    if (typeof result == "string") {
        result = replaceSpecialChars(result);
    }
    if ("NONE" !== data) {
        var empAllocID = full["EmpAllocID"];
        result = "<a href='" + ResolveUrl("~/ng/employee-allocations/") + empAllocID + "' >" + result + "</a>";
    }
    return result;
}
function formatCommDefaultScheduleLink(data, type, full) {
    var result = data;
    if (null != data) {
        var commID = full["CommID"];
        result = "<a href='" + ResolveUrl("~/ng/schedules/") + commID + "' >" + data + "</a>";
    }
    else {
        result = "";
    }
    return result;
}
function formatOverrideScheduleLink(data, type, full) {
    var result = data;
    if ("NONE" !== data && null !== data) {
        var overrideID = full["OverrideID"];
        result = "<a href='" + ResolveUrl("~/ng/plan/") + overrideID + "' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatEmpOverrideScheduleLink(data, type, full) {
    var result = data;
    if ("NONE" !== data && null !== data) {
        var EmpOverrideID = full["EmpOverrideID"];
        result = "<a href='" + ResolveUrl("~/ng/employee-plan") + "/" + EmpOverrideID + "' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatClosedLoanDetailsLink(data, type, full) {
    var result = data;
    if ("NONE" !== data) {
        var LoanNo = full["LoanNo"];
        result = "<a href='" + ResolveUrl("~/ng/loan-details/") + LoanNo + "' >" + data + "</a>";
    }
    return result;
}
function formatEmpCommViewLink(data, type, full) {
    var result = data;
    if ("NONE" !== data) {
        var EmpID = full["EmpID"];
        result = "<a href='" + ResolveUrl("~/ng/employee-details/") + EmpID + "#comp' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatEmpCommViewLinkLO(data, type, full) {
    var result = data;
    var EmpID = full["EmpID"];
    var hasLink = full["HasLinkLO"];
    if (hasLink) {
        result = "<a href='" + ResolveUrl("~/ng/employee-details/") + EmpID + "#comp' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatEmpCommViewLinkProc(data, type, full) {
    var result = data;
    var EmpID = full["ProcID"];
    var hasLink = full["HasLinkProc"];
    if (hasLink) {
        result = "<a href='" + ResolveUrl("~/ng/employee-details/") + EmpID + "#comp' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatEmpCommViewLinkBM(data, type, full) {
    var result = data;
    var EmpID = full["BrMgrID"];
    var hasLink = full["HasLinkBrMgr"];
    if (hasLink) {
        result = "<a href='" + ResolveUrl("~/ng/employee-details/") + EmpID + "#comp' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatPayrollPeriodsViewEditLink(data, type, full) {
    var result = data;
    var ld = full["LockDown"];
    if (ld == null) {
        result = "<a href='" + ResolveUrl("~/ng/payroll-periods") + "/" + data + "/edit" + "' >Edit</a>";
    }
    else {
        result = "<a href='" + ResolveUrl("~/ng/payroll-periods") + "/" + data + "' >View</a>";
    }
    return result;
}
function formatPayrollTransactionDescriptionLink(data, type, full) {
    var result = data;
    if (type === "display") {
        var overrideID = full["OverrideID"];
        var empID = full["EmpID"];
        var doLumpSum = full["DoLumpSum"];
        if ((doLumpSum === 1) || (doLumpSum === 2)) {
            result = "<a href='" + ResolveUrl("~/Reporting/Default.aspx") + "?ReportID=OverrideTransactions&EmpID=" + empID + "&OverrideID=" + overrideID + "' >" + replaceSpecialChars(data) + "</a>";
        }
    }
    return result;
}
function formatPayrollTransactionDescriptionLinkNew(data, type, full) {
    var result = data;
    if (typeof result == "string") {
        result = replaceSpecialChars(result);
    }
    if (type === "display") {
        var overrideID = full["OverrideId"];
        var empID = full["EmpId"];
        var doLumpSum = full["DoLumpSum"];
        if ((doLumpSum === 1) || (doLumpSum === 2)) {
            result = "<a href='" + ResolveUrl("~/Reporting/Default.aspx") + "?ReportID=OverrideTransactions&EmpID=" + empID + "&OverrideID=" + overrideID + "' >" + replaceSpecialChars(result) + "</a>";
        }
    }
    return result;
}
function formatEditDocument(data, type, full) {
    var result;
    result = "<a href='#' class='doc-edit' >" + data + "</a>";
    return result;
}
function formatAbbrLeadSource(data, type, full) {
    var result = data;
    var ellipsis = "";
    if ((null != result) && (result.length > 10)) {
        ellipsis = "...";
        result = result.substr(0, 10);
    }
    if (null != result) {
        result = result + ellipsis;
    }
    return result;
}
function formatVolGeneratedBy(data, type, full) {
    var result = "";
    switch (data.toLowerCase()) {
        case "company":
            result = "All Company";
            break;
        case "region":
            result = "My Region";
            break;
        case "masterbr":
            result = "My Master Branch";
            break;
        case "branch":
            result = "My Branch";
            break;
        case "myloans":
            result = "My Loans";
            break;
        case "selectmasterbranches":
            result = "Selected Master Branches";
            break;
        case "selectbr":
            result = "Selected Branches";
            break;
        case "selectemp":
            result = "Selected Employees";
            break;
        default:
            result = "Unsupported";
            break;
    }
    return result;
}
function formatOverrideDateRange(data, type, full) {
    var result = data;
    var StartDt = full["StartDt"];
    var StopDt = full["StopDt"];
    if (type === "display") {
        result = formatDateMMDDYYYYRaw(data);
        if (null != StopDt) {
            result += " - " + formatDateMMDDYYYYRaw(StopDt);
        }
    }
    return result;
}
function formatDirectoryBranchesRegionLink(data, type, full) {
    var result = data;
    var RegID = full["RegID"];
    var RegLoc = full["RegLoc"];
    var RegAbbr = full["RegAbbr"];
    if (type === "display") {
        var urlFormat = "<a href=/ng/region-details?RegID=[[[REGID]]]&RegNo=[[[REGLOC]]]>[[[REGABBR]]]</a>";
        result = urlFormat.replace("[[[REGID]]]", RegID).replace("[[[REGLOC]]]", RegLoc).replace("[[[REGABBR]]]", RegAbbr);
    }
    return result;
}
function formatChannelType(data, type, full) {
    var result = data;
    switch (result.toUpperCase()) {
        case "A":
            result = "Retail-A";
            break;
        case "B":
            result = "Retail-B";
            break;
        case "C":
            result = "Correspondent";
            break;
        case "D":
            result = "Consumer Direct";
            break;
        case "J":
            result = "Joint Venture";
            break;
        case "L":
            result = "Lender";
            break;
        case "O":
            result = "Commercial";
            break;
        case "R":
            result = "Retail";
            break;
        case "V":
            result = "Reverse Mortgage";
            break;
        case "W":
            result = "Wholesale";
            break;
        default:
            break;
    }
    return result;
}
function formatConfirmationsLink(data, type, full) {
    var result = data;
    var sched = full["SchedAlloc"];
    if (full["ID"] == null) {
        return result;
    }
    if (sched === "ALLOCATION") {
        result = "<a href='" + ResolveUrl("~/ng/commission-allocations/") + full["ID"] + "' >" + replaceSpecialChars(data) + "</a>";
    }
    else if (sched === "SCHEDULE") {
        result = "<a href='" + ResolveUrl("~/ng/schedules/") + full["ID"] + "' >" + replaceSpecialChars(data) + "</a>";
    }
    else if (sched === "OVERRIDE") {
        result = "<a href='" + ResolveUrl("~/ng/employee-plan/") + full["ID"] + "' >" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatEmailMsg(data, type, full) {
    var result = data;
    if ("display" === type) {
        result = "<a onClick='GetEmailDialog(" + full["EmailID"] + ")'>View</a><div id='email-" + full["EmailID"] + "' style='display:none;text-align:left;max-width:800px;'></div>";
    }
    return result;
}
function formatMinCommTiers(data, type, full) {
    var result = data;
    if ("display" === type) {
        if (full["MinMaxType"] === "Per Tier") {
            if (full["EmpCommID"] != null) {
                result = "<a onClick='GetEmpCommTiersDialog(" + full["EmpCommID"] + ")'>" + full["MinTiersShort"] + "</a><div id='EmpComm-" + full["EmpCommID"] + "' style='display:none;text-align:left;max-width:800px;'></div>";
            }
            else if (full["EmpOverrideID"] != null) {
                result = "<a onClick='GetEmpOverrideTiersDialog(" + full["EmpOverrideID"] + ")'>" + full["MinTiersShort"] + "</a><div id='EmpOverrideID-" + full["EmpOverrideID"] + "' style='display:none;text-align:left;max-width:800px;'></div>";
            }
        }
    }
    return result;
}
function formatMaxCommTiers(data, type, full) {
    var result = data;
    if ("display" === type) {
        if (full["MinMaxType"] === "Per Tier") {
            if (full["EmpCommID"] != null) {
                result = "<a onClick='GetEmpCommTiersDialog(" + full["EmpCommID"] + ")'>" + full["MaxTiersShort"] + "</a><div mhi-dialog id='EmpComm-" + full["EmpCommID"] + "' height='auto' width='400' style='display:none;text-align:left;'></div>";
            }
            else if (full["EmpOverrideID"] != null) {
                result = "<a onClick='GetEmpOverrideTiersDialog(" + full["EmpOverrideID"] + ")'>" + full["MinTiersShort"] + "</a><div id='EmpOverrideID-" + full["EmpOverrideID"] + "' style='display:none;text-align:left;max-width:800px;'></div>";
            }
        }
    }
    return result;
}
function getRegionInfoFormat(regID) {
    var result;
    $.ajax({
        type: "POST",
        url: ResolveUrl("~/LoanData.asmx") + "/GetRegionDetail",
        data: JSON.stringify({
            RegID: regID
        }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        async: false,
        success: function (d) {
            result = d.d;
        }
    });
    return result;
}
function getBranchInfoFormat(brID) {
    var result = null;
    if (brID != null && brID !== "") {
        $.ajax({
            type: "POST",
            url: ResolveUrl("~/LoanData.asmx") + "/GetBranchByBrID",
            data: JSON.stringify({
                BrID: brID
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (d) {
                result = d.d;
            }
        });
    }
    return result;
}
function getPayrollSystemFormat(psID) {
    var result = null;
    if (psID != null && psID !== "") {
        $.ajax({
            type: "POST",
            url: ResolveUrl("~/LoanData.asmx") + "/GetPayrollSystemByID",
            data: JSON.stringify({
                PayrollSystemID: psID
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (d) {
                result = d.d;
            }
        });
    }
    return result;
}
function getGLSystemFormat(glsID) {
    var result = null;
    if (glsID != null && glsID !== "") {
        $.ajax({
            type: "POST",
            url: ResolveUrl("~/LoanData.asmx") + "/GetGLSystemByID",
            data: JSON.stringify({
                GLSystemID: glsID
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (d) {
                result = d.d;
            }
        });
    }
    return result;
}
function getLeadSourceFormat(lsID) {
    var result = null;
    var csApiURL = window['csApiUrl'] || "";
    if (lsID != null && lsID !== "") {
        $.ajax({
            type: "GET",
            url: csApiURL + "/lead-sources/" + lsID.toString(),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            async: false,
            success: function (data) {
                var _a;
                result = (_a = data.find(function (leadSource) { return leadSource.leadSourceID.toString() === lsID.toString(); })) === null || _a === void 0 ? void 0 : _a.leadSourceName;
            }
        });
    }
    return result;
}
function formatCompanyParamValue(data, type, full) {
    var dataType = full["DataType"];
    return formatCompanyParamValueRaw(data, dataType);
}
function formatCompanyParamValueRaw(data, dataType) {
    var result = data;
    if (null != result) {
        switch (dataType) {
            case "bool":
                result = formatTrueFalseRaw(data);
                break;
            case "custom:BrID":
                var br = getBranchInfoFormat(data);
                if (null != br) {
                    result = br.LOCAbbr;
                }
                break;
            case "custom:RegID":
                var reg = getRegionInfoFormat(data);
                if (null != reg) {
                    result = reg.LOC + " " + reg.RegionName;
                }
                break;
            case "custom:AccessLevel":
            case "custom:AL2Plus":
            case "custom:AL3Plus":
                result = formatAccessLevelRaw(data);
                break;
            case "custom:PayrollSystem":
                var ps = getPayrollSystemFormat(data);
                if (null != ps) {
                    result = ps.FriendlyText;
                }
                break;
            case "custom:GLSystem":
                var gls = getGLSystemFormat(data);
                if (null != gls) {
                    result = gls.FriendlyText;
                }
                break;
            case "custom:LeadSource":
                var leadSourceName = getLeadSourceFormat(data);
                if (null != leadSourceName) {
                    result = leadSourceName;
                }
                break;
            case "custom:LoanSource":
                var loanSource = getLeadSourceFormat(data);
                if (null != loanSource) {
                    result = loanSource[0].LeadSourceName;
                }
                break;
            case "custom:MultipleEmails":
                result = result.split(";").join("; ");
                break;
            case "custom:EmployeeIdentifier":
                result = formatEmployeeIdentifierRaw(data);
                break;
        }
    }
    return result;
}
function replaceSpecialChars(str) {
    if (str) {
        var strng = str;
        return strng
            .replace(/&/g, "&amp;")
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
    }
    return str;
}
function formatCompanyParamEdit(data, type, full) {
    var result = data;
    if (full["IsEditable"] !== true) {
        return "";
    }
    if ("display" === type) {
        result = "<a onClick='GetParamEditDialog(\"" + full["CompanyParamID"] + "\", \"" + full["ParamName"] + "\", \"" + replaceSpecialChars(full["FriendlyName"]) + "\", \"" + encodeURIComponent(full["ParamValue"]) + "\", \"" + full["ParamDefaultValue"] + "\", \"" + full["DataType"] + "\")'>Edit</a>";
        result = result + "<div id='param-" + full["ParamName"] + "' style='display:none;text-align:left;'></div>";
    }
    return result;
}
function formatHiddenRecordRegion(data, type, full) {
    var result = data;
    if (data !== "*") {
        result = "<a href='" + ResolveUrl("/ng/region-details") + "?RegID=" + full["RegID"] + "&RegNo=" + full["RegNo"] + "'>" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatHiddenRecordBranch(data, type, full) {
    var result = data;
    if (data !== "*") {
        result = "<a href='" + ResolveUrl("~/ng/branch-details") + "?BrNo=" + full["LOC"] + "'>" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatHiddenRecordEmployee(data, type, full) {
    var result = data;
    if (data !== "*") {
        result = "<a href='" + ResolveUrl("~/ng/employee-details/") + full["EmpID"] + "'>" + replaceSpecialChars(data) + "</a>";
    }
    return result;
}
function formatVerifyComments(data, type, full) {
    var result = data;
    if (null != data) {
        result = data.replace(/\$\{\|\}/g, '<br/>');
    }
    return result;
}
function formatMarketingAccountBalanceDetailsLink(data, type, full) {
    var result = data;
    if (full["LumpSumEmpOverrideID"] > 0 && full["ActiveDt"] != null && full["InactiveDt"] != null) {
        result = "<a href='" + ResolveUrl("~/Reporting/Default.aspx") + "?ReportID=OverrideTransactions&OverrideID=" + full["OverrideID"] + "&FromDate=" + full["ActiveDt"] + "&ToDate=" + full["InactiveDt"] + "' >View</a>";
    }
    else if (full["LumpSumEmpOverrideID"] > 0 && full["ActiveDt"] != null && full["InactiveDt"] == null) {
        result = "<a href='" + ResolveUrl("~/Reporting/Default.aspx") + "?ReportID=OverrideTransactions&OverrideID=" + full["OverrideID"] + "&FromDate=" + full["ActiveDt"] + "' >View</a>";
    }
    else if (full["LumpSumEmpOverrideID"] > 0 && full["ActiveDt"] == null && full["InactiveDt"] == null) {
        result = "<a href='" + ResolveUrl("~/Reporting/Default.aspx") + "?ReportID=OverrideTransactions&OverrideID=" + full["OverrideID"] + "' >View</a>";
    }
    else if (full["TranID"] > 0 && full["TransactionType"] == 'ept') {
        result = "<a href='" + ResolveUrl("~/ng/manual-adjustment/view/") + full["TranID"] + "' >View</a>";
    }
    else if (full["TranID"] > 0 && full["TransactionType"] == 'hpt') {
        result = "<a href='" + ResolveUrl("~/ng/held-transaction/view/") + full["TranID"] + "' >View</a>";
    }
    else {
        result = "";
    }
    return result;
}
function formatTextToPreventXSS(data, type, full) {
    var result = data;
    if (typeof result == "string") {
        result = replaceSpecialChars(result);
    }
    return result;
}
